import {SortOrder} from "ts-protocol-extension";
import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserSessionValueObject} from "../../../data/value-object/user/UserSessionValueObject";
import {UserSessionSearchOption} from "../../../data/search-option/user/UserSessionSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import ListPageWrapper from "../../ListPageWrapper";
import {UserSessionIO} from "../../../io/UserIO";
import {UserSessionDescription} from "../../../data/description/user/UserSessionDescription";
import {UserSessionDescriptor} from "../../../data/descriptor/user/UserSessionDescriptor";
import ListOption from "../../ListOption";
import {
    UserSessionSearchOptionDescription
} from "../../../data/description/user/UserSessionSearchOptionDescription";
import {
    applyUserSessionSearchOption,
    UserSessionSearchOptionField
} from "../../search-option-field/user/UserSessionSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserSessionValueObject[]>([])
    const option = useStatePair<UserSessionSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserSessionIO}
                items={items}
                option={option.value}
                index={index}
                description={UserSessionDescription}
                descriptor={UserSessionDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/sessions/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserSessionSearchOptionDescription}
                fields={UserSessionSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserSessionSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserSessionDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}